import React from 'react';
import PropTypes from 'prop-types';
import { getModifiers } from '@/shared/ui/core';
import Title from './Title.styled';

const modifierProps = [
  'xLarge',
  'small',
  'xSmall',
  'micro',
  'inverted',
  'sectionTitle',
  'pageTitle',
  'pageSecondTitle',
  'messageTitle',
  'profileTitle',
  'primary',
  'capitalize',
];

export default ({
  children,
  content,
  ...props
}) => (
  <Title
    modifiers={getModifiers(props, modifierProps)}
    {...props}
  >
    { content ?? children }
  </Title>
);

Title.propTypes = {
  as: PropTypes.string,
  content: PropTypes.string,
  modifiers: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

Title.defaultProps = {
  as: '',
  content: '',
  modifiers: '',
};
